export enum EConditionType {
    ALWAYS = 'always',
    ON_HOVER = 'on-hover',
}
